"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var __1 = require("../../..");
var Field_1 = __importDefault(require("../components/Field"));
var Label_1 = __importDefault(require("../components/Label"));
var TextArea_1 = __importDefault(require("../inputs/TextArea"));
var TextAreaField = function (_a) {
    var name = _a.name, label = _a.label, readOnly = _a.readOnly, toolTip = _a.toolTip, maxLength = _a.maxLength, disableLabel = _a.disableLabel, oneLine = _a.oneLine, topAlignLabel = _a.topAlignLabel, placeholder = _a.placeholder;
    return (react_1.default.createElement(Field_1.default, { topAlign: topAlignLabel },
        !disableLabel && react_1.default.createElement(Label_1.default, { htmlFor: name }, label),
        react_1.default.createElement(__1.Tooltip, { content: toolTip, disabled: !(toolTip === null || toolTip === void 0 ? void 0 : toolTip.length) },
            react_1.default.createElement("div", null,
                react_1.default.createElement(TextArea_1.default, { name: name, readOnly: readOnly, maxLength: maxLength, oneLine: oneLine, placeholder: placeholder })))));
};
TextAreaField.defaultProps = {
    readOnly: false,
    toolTip: undefined,
    maxLength: undefined,
    label: undefined,
    disableLabel: false,
    oneLine: false,
    topAlignLabel: false,
    placeholder: undefined,
};
exports.default = TextAreaField;
